import { useQuery } from "@tanstack/react-query";

import { categoriesKey } from "@/hooks/apis/queries/useCategoriesQuery/constants";

import { categoriesApiHandler } from "@/services/apiHandlers/categories";
import type { ICategories } from "@/services/apiHandlers/categories/types";

const useCategoriesQuery = (
  initialCategoriesFromServerSide: ICategories[] = [],
) => {
  const { data: categories } = useQuery({
    queryKey: [categoriesKey],
    queryFn: () => categoriesApiHandler.getCategories(),
    initialData: initialCategoriesFromServerSide,
    staleTime: Infinity,
    enabled: false,
  });

  const getTitleByAlias = (categoryAlias: string) => {
    const category = categories.find((c) => c.value === categoryAlias);

    return {
      title: category?.label || "Popular Apps",
      description:
        category?.description ||
        "Embraced by many users, these apps have become a top choice",
    };
  };

  return {
    categories,
    getTitleByAlias,
  };
};

export default useCategoriesQuery;
